<template>
  <div id="forge"
    role="presentation"
    class="container-fluid p-0 m-0">
    <template v-if="isAuthenticated">
      <navigation />

      <user-sidebar sidebar-id="myProfile"
        :visible="false"
        :active-user="myAccount" />

      <search-modal />

      <router-view v-if="!isLoading" />

      <page-footer v-if="$route.path !== '/map'" />
    </template>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import SearchModal from '@/components/search/SearchModal'
import UserSidebar from '@/components/user/UserSidebar'
import PageFooter from '@/components/page-footer/page-footer'

import { mapState } from 'vuex'

export default {
  name: 'App',

  components: {
    navigation: Navigation,
    'search-modal': SearchModal,
    'user-sidebar': UserSidebar,
    'page-footer': PageFooter,
  },

  computed: {
    ...mapState('user', ['isAuthenticated', 'myAccount']),
    ...mapState('network', ['selectedNetworkResource']),
    ...mapState('theme', ['currentTheme']),
    isLoading() {
      return this.$store.state.loading
    },
  },

}
</script>

<style lang="scss">
@import '@/styles/main.scss';

#forge {
  background-color: var(--bg-primary) !important;
  min-height: 100vh;
}
</style>
